import { captureError } from "./utils/logger";

const getName = (node: Node) => {
    const name = node.nodeName;
    return node.nodeType === 1
        ? name.toLowerCase()
        : name.toUpperCase().replace(/^#/, '');
};

const MAX_LEN = 100;

export const getSelector = (node: Node | null) => {
    let sel = '';

    try {
        while (node?.nodeType !== 9) {
            const el: Element = node as Element;
            const part = el.id
                ? '#' + el.id
                : [getName(el), ...Array.from(el.classList).sort()].join('.');
            if (sel.length + part.length > MAX_LEN - 1) {
                return sel || part;
            }
            sel = sel ? part + '>' + sel : part;
            if (el.id) {
                break;
            }
            node = el.parentNode;
        }
    } catch (error) {
        captureError(error, `Error generating selector. Node type: ${node?.nodeType}`);
    }
    return sel;
};
